import template from './field-type-switcher.jade';

export default angular
    .module('cian.addForm.fieldTypeSwitcher', [])
    .directive('cianAfHelperFieldTypeSwitcher', () => ({
        bindToController: {
            textName: '@',
            inputName: '@',
            inputModel: '=',
            inputModelName: '@',
            inputTextKey: '@?',
            inputValueKey: '@?',
            items: '=',
            defaultValue: '=',
        },
        controller(deviceService) {
          'ngInject';

          this.isMobile = deviceService.isMobile;

          this.inputTextKey = this.inputTextKey || 'text';
          this.inputValueKey = this.inputValueKey || 'value';
        },
        template,
        controllerAs: 'field',
    }))
    .name;
